module.exports = __webpack_public_path__ + "d664201f/img/menu-icon.5f8facae.svg";